
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    dataSet: {
      type: Object,
      default: () => ({ labels: [], ralan: [], igd: [], ranap: [] })
    }
  },
  computed: {
    chartData(): any {
      return {
        labels: this.dataSet.labels,
        datasets: [
          {
            label: "Rawat Jalan",
            data: this.dataSet.ralan,
            borderColor: "#1E88E5",
            backgroundColor: "rgba(30, 136, 229, 0.12)",
            pointBackgroundColor: "#1E88E5",
            pointRadius: 3,
            borderWidth: 2,
            lineTension: 0,
            fill: "origin"
          },
          {
            label: "Rawat Inap",
            data: this.dataSet.ranap,
            borderColor: "#43A047",
            backgroundColor: "#43A047",
            pointBackgroundColor: "#43A047",
            pointRadius: 3,
            borderWidth: 2,
            lineTension: 0,
            fill: false
          },
          {
            label: "IGD",
            data: this.dataSet.igd,
            borderColor: "#E53935",
            backgroundColor: "#E53935",
            pointBackgroundColor: "#E53935",
            pointRadius: 3,
            borderWidth: 2,
            lineTension: 0,
            fill: false
          }
        ]
      };
    },
    chartOptions(): any {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: { mode: "index", intersect: false },
        hover: { mode: "index", intersect: false },
        scales: {
          xAxes: [
            {
              gridLines: { display: false },
              ticks: { autoSkip: true, maxRotation: 0 }
            }
          ],
          yAxes: [
            {
              gridLines: { color: "rgba(0, 0, 0, 0.06)" },
              ticks: { beginAtZero: true, precision: 0 }
            }
          ]
        }
      };
    }
  },
  watch: {
    dataSet: {
      deep: true,
      handler() {
        (this as any).render();
      }
    }
  },
  mounted() {
    (this as any).render();
  },
  methods: {
    render() {
      (this as any).renderChart(this.chartData, this.chartOptions);
    }
  }
};
